var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirNotHeardRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 20,
    r: 17.5,
    stroke: "#A13636",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.242114 51.747C0.241569 52.8515 1.13656 53.7474 2.24113 53.748L20.2411 53.7568C21.3457 53.7574 22.2416 52.8624 22.2421 51.7578C22.2427 50.6532 21.3477 49.7574 20.2431 49.7568L4.2431 49.7489L4.25097 33.7489C4.25152 32.6444 3.35653 31.7485 2.25196 31.7479C1.14739 31.7474 0.251518 32.6424 0.250975 33.747L0.242114 51.747ZM22.7583 31.252L21.3448 29.837L0.828596 50.333L2.24211 51.748L3.65563 53.1629L24.1718 32.6669L22.7583 31.252Z",
    fill: "#A13636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirNotHeardRight);
export default __webpack_public_path__ + "static/media/AirNotHeardRight.d17603796e6f341d40219f1e4c0fbc01.svg";
export { ForwardRef as ReactComponent };